import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "gap", "name", "onChange", "orientation", "size", "value"],
  _excluded2 = ["onChange", "selectedValue", "value"],
  _excluded3 = ["onChange", "selectedValue", "value"];
import { Radio } from './Radio';
import { cloneChildren } from '../cloneChildren';
import { LayoutHorizontal } from '../Layout/LayoutHorizontal';
import { LayoutSpaceVertical } from '../Layout/LayoutSpaceVertical';
import { RadioCard } from './RadioCard';
import { jsx as _jsx } from "react/jsx-runtime";
export const RadioGroup = _ref => {
  let {
      children,
      gap,
      name,
      onChange,
      orientation = 'vertical',
      size,
      value
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const LayoutWrapper = orientation === 'horizontal' ? LayoutHorizontal : LayoutSpaceVertical;
  const defaultGap = orientation === 'horizontal' ? 'space' : '0';
  return /*#__PURE__*/_jsx(LayoutWrapper, Object.assign({}, rest, {
    gap: gap || defaultGap,
    children: cloneChildren({
      children,
      newProps: {
        name,
        onChange: newValue => onChange(newValue),
        selectedValue: value,
        size
      }
    })
  }));
};
RadioGroup.Radio = _ref2 => {
  let {
      onChange,
      selectedValue,
      value
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(Radio, Object.assign({}, rest, {
    checked: selectedValue === value,
    onChange: () => onChange === null || onChange === void 0 ? void 0 : onChange(value)
  }));
};
RadioGroup.RadioCard = _ref3 => {
  let {
      onChange,
      selectedValue,
      value
    } = _ref3,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  return /*#__PURE__*/_jsx(RadioCard, Object.assign({}, rest, {
    checked: selectedValue === value,
    onChange: () => onChange === null || onChange === void 0 ? void 0 : onChange(value)
  }));
};